import React from 'react';
import './Medicalinst.css';
import fittingImage from '../../../imgs/medicalinst.webp'; 

const Medicalinst = () => {
  return (
    <div className="medical-container"data-aos="fade-down">
      <img src={fittingImage} alt="Fitting Corrosion" className="medical-image" />
    </div>
  );
};

export default Medicalinst;
